import React from 'react';
import { FadeIn, Section, Button } from './ui';
import { Check } from 'lucide-react';
export function BaseOfferSection() {
  return <Section variant="dark" id="pricing" className="!py-3 md:!pb-4 md:!pt-14" data-id="element-15">
      <FadeIn data-id="element-16">
        <div className="text-center mb-3 md:mb-5" data-id="element-17">
          <p className="text-brand-orange text-[10px] md:text-xs font-bold tracking-widest uppercase mb-1 md:mb-2" data-id="element-18">
            Elegí tu plan
          </p>
          <h2 className="text-xl md:text-4xl font-black text-white" data-id="element-19">
            MATEMÁTICA 360
          </h2>
        </div>

        {/* Base Offer Card — structured but subdued */}
        <div className="bg-dark-light/40 border border-gray-800 rounded-xl md:rounded-2xl p-3.5 md:p-7" data-id="element-20">
          <div className="flex items-center justify-between mb-2 md:mb-3" data-id="element-21">
            <h3 className="text-base md:text-xl font-bold text-white" data-id="element-22">
              Sistema Completo
            </h3>
            <span className="text-gray-500 text-[9px] md:text-xs font-medium px-2 py-0.5 rounded-full border border-gray-700" data-id="element-23">
              SISTEMA BASE
            </span>
          </div>

          <p className="text-gray-400 text-[11px] md:text-sm mb-2.5 md:mb-4 leading-snug md:leading-relaxed" data-id="element-24">
            6 PDFs + 3 bonus descargables al instante. Todo lo que necesitás
            para planificar, dar clase y evaluar.
          </p>

          <div className="space-y-1 md:space-y-2 mb-3 md:mb-5" data-id="element-25">
            <div className="flex items-center gap-1.5 md:gap-2 text-[11px] md:text-sm text-gray-300" data-id="element-26">
              <Check size={12} className="text-brand-orange shrink-0" data-id="element-27" />
              <span data-id="element-28">
                6 Tomos completos (scripts, guías, exámenes, protocolos)
              </span>
            </div>
            <div className="flex items-center gap-1.5 md:gap-2 text-[11px] md:text-sm text-gray-300" data-id="element-29">
              <Check size={12} className="text-brand-orange shrink-0" data-id="element-30" />
              <span data-id="element-31">
                3 Bonus: Plantillas MAI/PPI · Prompts IA · Planilla de Notas
              </span>
            </div>
            <div className="flex items-center gap-1.5 md:gap-2 text-[11px] md:text-sm text-gray-300" data-id="element-32">
              <Check size={12} className="text-brand-orange shrink-0" data-id="element-33" />
              <span data-id="element-34">PDF descargable al instante · Pago único</span>
            </div>
          </div>

          <div className="text-center mb-2.5 md:mb-4" data-id="element-35">
            <span className="text-gray-500 text-[10px] md:text-xs line-through mr-1.5" data-id="element-36">
              $59.910
            </span>
            <span className="text-2xl md:text-4xl font-black text-brand-orange" data-id="element-37">
              $19.990
            </span>
          </div>

          <Button variant="outline" className="text-xs md:text-base !min-h-[40px] md:!min-h-[52px] !py-2 md:!py-4" data-id="element-38">
            <span data-id="element-39">QUIERO EL SISTEMA BASE →</span>
            <span className="text-[9px] md:text-xs font-normal text-brand-orange/60" data-id="element-40">
              Pago único · Acceso inmediato · Garantía 7 días
            </span>
          </Button>
        </div>
      </FadeIn>
    </Section>;
}